import Region, { RegionType } from '@/creditflowresearch/domain/Region';

const USOA_ABBR_SHORT = 'US';

const getRegionPrefixForTitle = (regionIds: string[], separator: string = ' '): string => {
  if (regionIds.length === 1) {
    const [regionId] = regionIds;
    const abbreviation = Region.getAbbreviation(regionId);

    if (!abbreviation) {
      return '';
    }

    return (Region.isOfType(regionId, RegionType.USOA) ? USOA_ABBR_SHORT : abbreviation) + separator;
  }

  return '';
};

export default getRegionPrefixForTitle;
